import { IUserPaymentTransactionResponse, MutationType, PromotionPlanInfo } from 'store/sagas/apiService/types';
import { PaymentMethod, PrivateUserMonetizationSource } from 'store/state/app';
import { IMutationResponse } from 'store/state/mutationsResponse/selectors';
import { IBulletinInput } from 'utils/entities';


export enum TranzilaModalType {
  Loading = 'loading',
  Initiation = 'initiation',
  Processing = 'processing',
  CardInfo = 'cardInfo',
  Fail = 'fail',
  Success = 'success',
  Paying = 'paying',
  CardInitiation = 'cardInitiation',
  MethodInitiation = 'methodInitiation',
  Method = 'method',
}

export enum TranzilaPaymentMethod {
  Card = 'CARD',
  Other = 'OTHER',
}
export interface HostedFields {
  charge: (data: any, callback: (error: any, response: any) => void) => void;
  onEvent: (event: string, callback: (result: any) => void) => void;
  chargeGpay: (a: any, b: any) => void;
}

export interface TranzilaModalState {
  bulletinId?: string;
  planInfo?: PromotionPlanInfo | null;
  modalType: TranzilaModalType | null;
  listing?: IBulletinInput;
  paymentDealType?: string;
  isUploadFlow?: boolean;
}

export interface HostedFieldsProps {
  modalState?: TranzilaModalState | null;
  source?: PrivateUserMonetizationSource;
  handshakeState?: IMutationResponse<MutationType.InitHostedFieldsPayment>;
  toggleModal?: (plan: TranzilaModalState | null) => void;
  onPaymentSubmit?: (payload: { method: PaymentMethod; paymentId: string }) => void;
  paymentResult?: IUserPaymentTransactionResponse;
  isPaymentResultLoading?: boolean;
  fieldsErrorState: HostedFieldsErrors;
  isGoogleEnable?: boolean;
  setModal?: (data: TranzilaModalState | null) => void;
}

export interface ITranzilaHostedFieldsModalProps {
  productId: string;
  contactName: string;
  phone: string;
}

export interface HostedFieldsErrors {
  'credit_card_number'?: boolean | null;
  'cvv'?: boolean | null;
  'expiry'?: boolean | null;
  'card_holder_id_number'?: boolean | null;
}
